import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import ModalContext from '~/context/home/ModalContext';
import decodeCvnaId from '~/utilities/cvnaId';
import { ListenerEvent, type ListenerEventType } from './constants';

type SaveSearchPayload = {
  cvnaid: string;
};

function isSaveSearchMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, SaveSearchPayload> {
  return (
    message.event === ListenerEvent.SaveSearch && message.payload.cvnaid != null
  );
}

export default function useSaveSearchHandler(): MessageHandler<
  ListenerEventType,
  SaveSearchPayload
> {
  const { setSaveSearchModalOpen } = useContext(ModalContext);

  return useMemo(
    () =>
      new MessageHandler(isSaveSearchMessage, message => {
        setSaveSearchModalOpen(
          true,
          decodeCvnaId(message.payload.cvnaid)?.filters ?? {}
        );
      }),
    [setSaveSearchModalOpen]
  );
}
